module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-unknown-2.45d6ba04.svg";